import { render, staticRenderFns } from "./ItemsTableLTL.vue?vue&type=template&id=22228e45&scoped=true&"
import script from "./ItemsTableLTL.vue?vue&type=script&lang=js&"
export * from "./ItemsTableLTL.vue?vue&type=script&lang=js&"
import style0 from "./ItemsTableLTL.vue?vue&type=style&index=0&id=22228e45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22228e45",
  null
  
)

export default component.exports